import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import logo from '../../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';
import { Icon24MenuOutline } from '@vkontakte/icons';
import { getCookie } from '../../utils/utils';
import UserStore from '../../store/UserStore';
import AuthStore from '../../store/auth/AuthStore';

interface IHeaderProps {
  title?: string;
}

const Header: React.FC<IHeaderProps> = observer((props) => {
  const [menuShowed, setMenuShowed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
      async function getUserData() {
        if (getCookie('AccessToken')) {
          UserStore.getUserData();
        }
        else {
          await AuthStore.refresh();
        }
      }
    
      getUserData();
    });
  
  return (
    <>
      <div className="header">
        <div className="container">
          <div className="header--inner">
            <div className="header__logo" onClick={() => navigate('/')}>
              <img className="header__logo-image" src={logo} alt='logotype' />
              <h1 className="header__logo-title">ScoReflect{props.title ? ` - ${props.title}`: ""}</h1>
            </div>
            <ul className='header__menu'>
              <li onClick={() => { setMenuShowed(false); navigate('/'); }}>Главная</li>
              {UserStore.id ?
              <>
              {UserStore.roleId === 'b15ba589-f095-4b50-8ed3-425350d90e8d' ?
              <li onClick={() => { setMenuShowed(false); navigate('/admin'); }}>Админка</li> :
              null
              }
              <li onClick={() => { setMenuShowed(false); navigate('/profile'); }}>Профиль</li>
              <li onClick={() => { setMenuShowed(false); UserStore.logout(navigate); }}>Выход</li>
              </> :
              <li onClick={() => { setMenuShowed(false); navigate('/auth'); }}>Вход</li>}
            </ul>
          </div>
        </div>
      </div>
      <div className="header-mobile">
        <div className="header__logo" onClick={() => navigate('/')}>
          <img className="header__logo-image" src={logo} />
          <h1 className="header__logo-title">ScoReflect</h1>
        </div>
        <div className="header__menu">
          <Icon24MenuOutline className='header__menu-icon' color='var(--sr--color_text_secondary)' onClick={() => setMenuShowed(!menuShowed)} />
          <ul className='header__menu-content' style={{ display: menuShowed ? 'block' : 'none' }}>
            <li onClick={() => { setMenuShowed(false); navigate('/'); }}>Главная</li>
              {UserStore.id ?
              <>
              {UserStore.roleId === 'b15ba589-f095-4b50-8ed3-425350d90e8d' ?
              <li onClick={() => { setMenuShowed(false); navigate('/admin'); }}>Админка</li> :
              null
              }
              <li onClick={() => { setMenuShowed(false); navigate('/profile'); }}>Профиль</li>
              <li onClick={() => { setMenuShowed(false); UserStore.logout(navigate); }}>Выход</li>
              </> :
              <li onClick={() => { setMenuShowed(false); navigate('/auth'); }}>Вход</li>}
          </ul>
        </div>
      </div>
    </>
  );
});

export default Header;